import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MainContent from "./Components/MainContent/MainContent"
import ProductList from "./Components/ProductList/ProductList"
import Header from "./Components/Header/Header";
import Footer from "./Components/Footer/Footer";
import ProductDetails from "./Components/ProductDetails/ProductDetails";
import AboutUsMore from "./Components/AboutUsMore/AboutUsMore";
import ContactUs from "./Components/Contact/ContactUs";
import Enquiry from "./Components/Enquiry/Enquiry";
import ProductEnquiry from "./Components/Enquiry/ProductEnquiry";
import Thankyou from "./Components/Thankyou/Thankyou";
import PrThank from "./Components/Thankyou/PrThank";

function App() {
  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="/" element={<MainContent />} />
        <Route path="/Product/:catId" element={<ProductList />} />
        <Route path="/Product/:catId/:productId" element={<ProductDetails />} />
        <Route path="/AboutUs" element={<AboutUsMore />} />
        <Route path="/Thankyou" element={<Thankyou />} />
        <Route path="/PrThank" element={<PrThank />} />
        <Route path="/ContactUs" element={<ContactUs />} />
        <Route path="/Enquiry" element={<Enquiry />} />
        <Route path="/ProductEnquiry" element={<ProductEnquiry />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;